import formatNumberWithCommas from "components/Common/CommaSeparator";
import { downloadBillingDataExcel, vendorInvoiceListExcel } from "helpers/fakebackend_helper";
import { API_URL } from "helpers/url_helper";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Modal, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { billAmountList, vendorInvoiceList } from "store/actions";

const VendorInvoiceModal = ({ isOpen, toggle, filterResponse }) => {
  const dispatch = useDispatch();
  const billAmountListState = state =>
    state.Dashboard?.vendorInvoiceList?.data;
  const billAmount = useSelector(billAmountListState);

  useEffect(() => {
    if(isOpen===true){

    dispatch(vendorInvoiceList({ filter: filterResponse }));
    }
  }, [filterResponse, dispatch,isOpen]);

  const handleExport = async() => {
    // Construct the URL for download
    const value = {
      filter:filterResponse,
      type: 'VendorInvoice'
    } 
    const downloadUrl = await vendorInvoiceListExcel(value)
   
  }
  const handleDownloadInvoice = billingId => {
    // Construct the URL for download
    const downloadUrl = `${API_URL}/api/download-invoice-pdf/${billingId}`

    // Create an anchor element
    const anchorElement = document.createElement("a")
    anchorElement.href = downloadUrl
    anchorElement.target = "_blank" // Open in a new tab
    anchorElement.download = "invoice.pdf" // Optional: specify a filename for the downloaded file

    // Append the anchor element to the document body (required in some browsers)
    document.body.appendChild(anchorElement)

    // Trigger a click event on the anchor element
    anchorElement.click()

    // Clean up: remove the anchor element from the document body
    document.body.removeChild(anchorElement)
  }
  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Vendor Invoice List
        </h5>
        <button
          onClick={handleExport}
          type="button"
          className="btn btn-primary btn-sm me-4"
        >
          Export
        </button>
        <button
          onClick={toggle}
          type="button"
          className="close mt-2"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <SimpleBar style={{ maxHeight: "60vh", overflowX: "auto" }}>
          <div style={{ minWidth: "100%" }}>
            <Table className="table table-striped mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Vendor Name</th>
                  <th>Invoice No.</th>
                  <th>Invoice Date</th>
                  <th>Invoice Amount</th>
                  <th>Amount Paid</th>
                  <th>Status</th>
                  
                </tr>
              </thead>
              <tbody>
                {(billAmount || []).map((row, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{row.vendor_name}</td>
                    <td>{row.invoice_no}</td>
                    <td>{row.invoice_date}</td>
                    <td>{formatNumberWithCommas(row.invoice_amount)}</td>
                    <td>{formatNumberWithCommas(row.amount_paid)}</td>
                    <td>{row.is_paid === 1 ? 'Paid' : "Unpaid" }</td>
                    
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  );
};

export default VendorInvoiceModal;
